import { put } from 'redux-saga/effects';
import EasyRedux from '../../../utils/EasyRedux';
import handleSagaError from '../../handleSagaError';

const key = 'INVOICE/PREPARE';

export const { actionTypes, actions, reducer } = new EasyRedux(key);

export function* watchGetInvoicePrepare(
  client,
  { payload: { resolve, reject } }
) {
  try {
    const response = yield client.post('merchant/order/prepare');
    yield put(actions.loadSuccess(response.result));
    resolve && resolve(response.result);
  } catch (e) {
    reject && reject(e);
    yield put(actions.loadFailure(e));
    yield handleSagaError(e);
  }
}

export default reducer;
